module.exports = __webpack_public_path__ + "static/media/background_sidebar.4ac77441.png";